export const LANGUAGE = "AQCHAM_LANGUAGE";
export const language = localStorage.getItem(LANGUAGE);
